import { appEntry } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20and%20tablet%20displaying%20movie%20streaming%20interface%2C%20warm%20cinematic%20lighting%2C%20cozy%20living%20room%20background%2C%20clean%20minimal%20aesthetic%2C%20soft%20golden%20light%2C%20no%20text%20on%20screens&width=700&height=500&seq=app-section&orientation=landscape"
              alt="七七影院多平台观影体验"
              title="七七影院手机平板电脑全平台支持"
              className="w-full h-auto rounded-xl object-cover"
              style={{ aspectRatio: '7/5' }}
            />
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-5">{appEntry.title}</h2>
            <p className="text-foreground-600 leading-relaxed mb-6">{appEntry.subtitle}</p>
            <div className="grid grid-cols-2 gap-3">
              {appEntry.features.map((feat) => (
                <div key={feat} className="flex items-center gap-2 px-4 py-3 rounded-lg bg-background-50 border border-background-200/60">
                  <i className="ri-checkbox-circle-fill text-primary-500 text-lg"></i>
                  <span className="text-sm text-foreground-700 font-medium">{feat}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}